import * as React from "react";
import Svg, { Path } from "react-native-svg";

function Tick(props) {
  const { strokeColor = "#55CD1D" } = props || {};
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <Path
        d="M19.766 6.24a.788.788 0 00-1.132 0L9.05 16.027l-3.684-3.763a.788.788 0 00-1.132 0 .83.83 0 000 1.156l4.25 4.34a.789.789 0 001.132 0l10.15-10.366a.83.83 0 000-1.156z"
        fill={strokeColor}
      />
    </Svg>
  );
}

export default Tick;
